module.exports = __webpack_public_path__ + "img/Black-Box-img-tw-m.9157ab22.png";